<div class="tabs">
    <button [class.active]="activeTab=='business-account'" (click)="switchCategory('business-account')" mat-button>Business Accounts</button>
    <button [class.active]="activeTab=='tax-account'" (click)="switchCategory('tax-account')" mat-button>Tax Accounts</button>
    <button [class.active]="activeTab=='customer-account'" (click)="switchCategory('customer-account')" mat-button>Customer Accounts</button>
</div>

<div class="content">
    <ng-container *ngFor="let account of accounts">
        <div *ngIf="account.category == activeTab" class="account" [routerLink]="'/transactions/'+account.accountNumber">
            <div class="name">
                <h3>{{account.name}}</h3>
                <p>Acc {{account.accountNumber | account}}</p>
            </div>
            <div class="balance">
                {{account.balance | human}}
            </div>
        </div>
    </ng-container>
</div>